export default {
    vidfleetClips_id: "Id",
    vidfleetClips_companyName: "Nombre de la empresa",
    vidfleetClips_clipId: "Id de clip",
    vidfleetClips_unitId: "Id. de la unidad",
    vidfleetClips_unitLabel: "Etiqueta de la unidad",
    vidfleetClips_esn: "ESN",
    vidfleetClips_deviceModelName: "Nombre del modelo de dispositivo",
    vidfleetClips_errorMsg: "Mensaje de error",
    vidfleetClips_startDate: "Fecha de inicio",
    vidfleetClips_endDate: "Fecha final",
    vidfleetClips_status: "Estado",
    vidfleetClips_createdOnDb: "Creado EN",
    vidfleetClips_no_data_to_display: "No hay datos que mostrar",
}